<script setup lang="ts">
import { loginState } from '../cross-app-frontend/firebase';
import ComplianceLayout from '@/ComplianceLayout.vue';
import { RouterView, useRoute } from 'vue-router';

const route = useRoute();
</script>

<template>
  <div v-if="loginState === 'initializing'" />
  <RouterView v-else-if="loginState === 'logged-out' || route.name === 'Login'" />
  <ComplianceLayout v-else />
</template>
